/* Insert polyfills here, they will be executed before running the app */
import 'intersection-observer'; // IE11 support

import 'react-app-polyfill/ie11';